module.exports = __webpack_public_path__ + "img/1t4B9bQrPdx6C8Ym1mU1b-.fe12e056.svg";